import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "z-10 max-w-full text-ellipsis overflow-hidden whitespace-nowrap text-sm text-white px-1 py-0.5 absolute top-0 right-0 bg-green-400"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "bg-neutral-200 aspect-[16/10] flex items-center justify-center"
}
const _hoisted_6 = { class: "mt-1 text-2xl font-medium" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = ["href"]

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductItem',
  props: {
    product: {}
  },
  setup(__props: any) {

const props = __props;

const fallbackImageFromDocuments = (documents: any[]) => {
  if (!documents) return null;

  return documents.find((doc) =>
    typeof doc.url === 'string' &&
    /\.(jpe?g|png|webp|gif|bmp|svg)$/i.test(doc.url)
  )?.url || null;
};

const displayImageUrl = computed(() => {
  if (props.product.images?.length) {
    return props.product.images[0]?.url;
  }

  return fallbackImageFromDocuments(props.product.documents);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.product.listingLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.product.listingLabel), 1))
      : _createCommentVNode("", true),
    (displayImageUrl.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "block w-full",
            src: displayImageUrl.value,
            alt: ""
          }, null, 8, _hoisted_4)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "material-symbols-outlined text-neutral-400 text-3xl" }, "house", -1)
        ]))),
    _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.product.title), 1),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("span", null, "Bebygd areal (BYA): ", -1)),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.product.footprint) + "m", 1),
          _cache[1] || (_cache[1] = _createElementVNode("sup", null, "2", -1))
        ])
      ]),
      _createElementVNode("div", null, [
        _cache[4] || (_cache[4] = _createElementVNode("span", null, "Bruksareal (BRA): ", -1)),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.product.usableArea) + "m", 1),
          _cache[3] || (_cache[3] = _createElementVNode("sup", null, "2", -1))
        ])
      ]),
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("span", null, "Antall soverom: ", -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.product.numBedrooms), 1)
      ])
    ]),
    _createElementVNode("a", {
      href: _ctx.product.url,
      class: "block absolute inset-0"
    }, null, 8, _hoisted_8)
  ]))
}
}

})